const cssStyles = () => `

@media screen and (orientation: landscape) {
  .AppBanner__appInfo {
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    height: 58px !important;
  }

  .AppBanner__secondaryCTA {
    display: none;
  }

  .AppBanner__continueButton {
    width: 270px !important;
  }

  .AppBanner__appCopy {
    font-size: 4vh !important;
  }

  .AppBanner__tabletAppCopy {
    font-size: 2.5vh !important;
  }
}

.AppBanner__seamlessBottom {
  display: flex;
  display: -webkit-flex;
}

.AppBanner__seamlessPrimerVisible {
  opacity: 1 !important;
}

.AppBanner__appInfo {
  transition: opacity 0.5s cubic-bezier(0.26, 0.87, 0.74, 0.93);
  -webkit-transition: opacity 0.5s cubic-bezier(0.26, 0.87, 0.74, 0.93);
  -webkit-backface-visibility: hidden;
  opacity: 1;
}

.AppBanner__hidden {
  opacity: 0 !important;
  pointer-events: none;
}
`;

export default cssStyles;
